<template>
  <div class="box" :style="{ backgroundColor: facade.background_color }">
    <div
			v-if="facade.list_style * 1 === 2"
			class="img-move-box"
			:style="{ paddingLeft: facade.padding_zy + 'px', alignItems: 'flex-start' }"
		>
			<div v-for="(item, index) in content.data" :key="index" style="display: flex; position: relative;">
				<img :src="item.url" class="img" :style="{marginRight: facade.image_space + 'px', borderRadius: facade.picture_radius + 'px'}" @click="goDetail(item)"/>
			</div>
			<div style="opacity: 0;" :style="{ paddingRight: (facade.padding_zy - facade.image_space) + 'px' }">|</div>
		</div>

		<div
			v-else
			class="width-fix-box"
			:style="{ paddingLeft: facade.padding_zy + 'px', paddingRight: facade.padding_zy + 'px' }"
		>
			<div v-for="(item, index) in content.data" :key="index" style="display: flex; position: relative;">
				<img :src="item.url" class="img width-100" :class="'ispic-' + index" :style="{marginBottom: facade.image_space + 'px', borderRadius: facade.picture_radius + 'px', width: '100%'}" @click="goDetail(item)"/>
				<!-- 热区区域 link_type 1热区 0单链接 -->
				 <div v-if="item.hotZoneList && item.hotZoneList.length && item.link_type * 1 === 1" class="area-box">
					<div
						v-for="(_item, _index) in item.hotZoneList"
						:key="_index"
						class="every-area"
						style="position: relative;"
						:style="{width: _item.width + 'px', height: _item.height+'px',left: _item.is_left+'px',top: _item.is_top+'px'}"
						@click.stop="goDetail(_item)"
					>

					</div>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
	data() {
		return {}
	},
	props: {
		facade: {
			type: [Object, Array]
		},
		content: {
			type: [Object, Array]
		}
	},
	watch: {
		
	},
	mounted() { },
	methods: {
		goDetail(item) {
			console.log('图片跳转：', item)
			this.$emit('go-next', item.link)
		}
	}
}
</script>

<style lang="scss" scoped>
.area-box {
	width: 100%;
	height: 100%;
	position: absolute;
	overflow: hidden;

	.every-area {
		position: absolute;
		width: r(96);
		height: r(96);
		left: 0;
		top: 0;
		// background: rgba(#2980b9, 0.4);
		// border: 1px solid #2589ff;
	}
}

.img-move-box {
	width: 100%;
	display: flex;
	padding-left: 12px;
	overflow: scroll;

	.img {
		width: 225px;
		// height: 110px;
		border-radius: 8px;
		margin-right: 10px;
		flex-shrink: 0;
	}
}

.width-fix-box{
	width: 100%;
	
	.img {
		width: 100%;
		/* height: r(96); */
		height: 100%;
	}
}
</style>